import { api } from '@/shared/api/axios';
import type { CreateDemoPayload, Demo, DemoDetail, DemosFilters, FeedbackPayload, UpdateDemoPayload } from '@/features/demos/types';
import type { MutationResponse } from './contracts';
import { demoPaths } from './paths';

export const demosApi = {
  async list(filters: DemosFilters = {}): Promise<Demo[]> {
    const { data } = await api.get<{ demos: Demo[] }>(demoPaths.list(filters));
    return data.demos ?? [];
  },
  async analytics<T extends object>(): Promise<T> { return (await api.get<T>(demoPaths.analytics)).data; },
  async detail(id: string): Promise<DemoDetail> { return (await api.get<DemoDetail>(demoPaths.detail(id))).data; },
  async create(payload: CreateDemoPayload): Promise<MutationResponse & { id: string; demo_code: string }> {
    return (await api.post<MutationResponse & { id: string; demo_code: string }>(demoPaths.create, payload)).data;
  },
  async update(id: string, payload: UpdateDemoPayload): Promise<MutationResponse> {
    return (await api.put<MutationResponse>(demoPaths.update(id), payload)).data;
  },
  async assign(id: string, assigned_to: string | null): Promise<MutationResponse> {
    return (await api.post<MutationResponse>(demoPaths.assign(id), { assigned_to })).data;
  },
  async addComment(id: string, comment: string, mentions: string[] = []): Promise<MutationResponse> {
    return (await api.post<MutationResponse>(demoPaths.comments(id), { comment, mentions })).data;
  },
  async addFeedback(id: string, payload: FeedbackPayload): Promise<MutationResponse> {
    return (await api.post<MutationResponse>(demoPaths.feedback(id), payload)).data;
  },
  async remove(id: string): Promise<MutationResponse> {
    return (await api.delete<MutationResponse>(demoPaths.remove(id))).data;
  },
};
